import React, { PropsWithChildren, useState } from 'react';
import { makeCSS } from '../../utils/makeCSS';
import { Theme } from '../../theme/themes';

interface Props extends PropsWithChildren {
  marginLeft?: number;
  /** Half the height of each node */
  nodeHeight: number;
}

const useCSS = makeCSS(
  ({
    theme,
    length,
    marginLeft
  }: { theme: Theme; length: number } & Props) => ({
    root: {
      position: 'relative',
      marginLeft: marginLeft || 32,
      '&::before': {
        content: `''`,
        position: 'absolute',
        left: 0,
        top: 0,
        width: '1px' /* Border thickness */,
        height: length /* Desired border length */,
        background: theme.color.line['02'] /* Border color */
      }
    }
  })
);

export const TreeNode = (props: Props) => {
  const { children, nodeHeight, ...restProps } = props;
  const [container, setRef] = useState<HTMLDivElement>(null);
  const [lastChildRef, setLastChildRef] = useState<HTMLDivElement>(null);

  const containerHeight = container?.getBoundingClientRect().height;
  const lastChildHeight = lastChildRef?.getBoundingClientRect().height;

  const classes = useCSS({
    length: containerHeight - lastChildHeight + nodeHeight / 2,
    ...restProps
  });

  return (
    <div ref={setRef} className={classes.root}>
      {React.Children.toArray(children).map((child, index) => {
        return (
          <div key={index} ref={setLastChildRef}>
            {child}
          </div>
        );
      })}
    </div>
  );
};
